import { getQueryClient } from '$lib/state/queryClient';

const qc = () => getQueryClient();

export const invalidateAfterLoadCreate = (unitId: number) => {
  qc().invalidateQueries({ queryKey: ['loads', { unitId }] });
};

export const invalidateAfterLoadDelete = (unitId: number) => {
  qc().invalidateQueries({ queryKey: ['loads', { unitId }] });
  qc().invalidateQueries({ queryKey: ['rcus', { unitId }] });
};

export const invalidateAfterRoomCreate = (unitId: number) => {
  qc().invalidateQueries({ queryKey: ['rooms', { unitId }] });
};

export const invalidateAfterRoomDelete = (unitId: number) => {
  qc().invalidateQueries({ queryKey: ['rooms', { unitId }] });
  qc().invalidateQueries({ queryKey: ['loads', { unitId }] });
  qc().invalidateQueries({ queryKey: ['input_devices', { unitId }] });
  qc().invalidateQueries({ queryKey: ['scenes', { unitId }] });
};

export const invalidateAfterZoneCreate = (unitId: number) => {
  qc().invalidateQueries({ queryKey: ['zones', { unitId }] });
};

export const invalidateAfterZoneDelete = (unitId: number) => {
  qc().invalidateQueries({ queryKey: ['zones', { unitId }] });
  qc().invalidateQueries({ queryKey: ['rooms', { unitId }] });
  qc().invalidateQueries({ queryKey: ['loads', { unitId }] });
  qc().invalidateQueries({ queryKey: ['input_devices', { unitId }] });
  qc().invalidateQueries({ queryKey: ['scenes', { unitId }] });
};

export const invalidateAfterInputDeviceUpdate = (unitId: number) => {
  qc().invalidateQueries({ queryKey: ['input_devices', { unitId }] });
};

export const invalidateAfterChannelPatch = (unitId: number) => {
  qc().invalidateQueries({ queryKey: ['rcu_channels'] });
  qc().invalidateQueries({ queryKey: ['din_channels'] });
  qc().invalidateQueries({ queryKey: ['rcus', { unitId }] });
};

export const invalidateAfterChannelCreate = (unitId: number) => {
  qc().invalidateQueries({ queryKey: ['rcu_channels'] });
  qc().invalidateQueries({ queryKey: ['din_channels'] });
  qc().invalidateQueries({ queryKey: ['rcus', { unitId }] });
  qc().invalidateQueries({ queryKey: ['loads', { unitId }] });
};

export const invalidateAfterChannelDelete = (unitId: number) => {
  qc().invalidateQueries({ queryKey: ['rcu_channels'] });
  qc().invalidateQueries({ queryKey: ['din_channels'] });
  qc().invalidateQueries({ queryKey: ['rcus', { unitId }] });
  qc().invalidateQueries({ queryKey: ['loads', { unitId }] });
};

export const invalidateAfterDinModuleCreate = (unitId: number, rcuId: number) => {
  qc().invalidateQueries({ queryKey: ['rcus', { unitId }] });
  qc().invalidateQueries({ queryKey: ['din_modules', { rcuId }] });
};

export const invalidateAfterSceneCreate = (unitId: number) => {
  qc().invalidateQueries({ queryKey: ['scenes', { unitId }] });
};

export const invalidateAfterSceneLoadUpdate = (unitId: number, sceneId: number) => {
  qc().invalidateQueries({ queryKey: ['scene_loads', { sceneId }] });
  qc().invalidateQueries({ queryKey: ['scene_loads', { unitId }] });
  qc().invalidateQueries({ queryKey: ['scenes', { unitId }] });
};

export const invalidateAfterProjectUpdate = () => {
  qc().invalidateQueries({ queryKey: ['projects'] });
};

export const invalidateAfterUnitUpdate = (projectId: number) => {
  qc().invalidateQueries({ queryKey: ['units', { projectId }] });
  qc().invalidateQueries({ queryKey: ['units', 'all'] });
};

export const invalidateAfterRcuUpdate = (unitId: number) => {
  qc().invalidateQueries({ queryKey: ['rcus', { unitId }] });
};

export const invalidateAfterLedSceneUpdate = (unitId: number) => {
  qc().invalidateQueries({ queryKey: ['led_scenes', { unitId }] });
  qc().invalidateQueries({ queryKey: ['input_devices', { unitId }] });
};

export const invalidateAfterProjectFilesUpdate = (projectId: number) => {
  qc().invalidateQueries({ queryKey: ['project_files', { projectId }] });
};

// Folder create/rename/delete can also change files' folder_id (delete moves
// them back to the root), so both caches need invalidating.
export const invalidateAfterProjectFileFoldersUpdate = (projectId: number) => {
  qc().invalidateQueries({ queryKey: ['project_file_folders', { projectId }] });
  qc().invalidateQueries({ queryKey: ['project_files', { projectId }] });
};

export const invalidateAfterProductsUpdate = () => {
  qc().invalidateQueries({ queryKey: ['products'] });
};

export const invalidateAfterCategoriesUpdate = () => {
  qc().invalidateQueries({ queryKey: ['categories'] });
};

export const invalidateAfterProductTypesUpdate = () => {
  qc().invalidateQueries({ queryKey: ['product_types'] });
  qc().invalidateQueries({ queryKey: ['products'] });
};
